<div class="wrapper">
  <div *ngFor="let message of messages; let index = index" [className]="'alert alert-' + message.className">
    <i (click)="close(index)" class="fa fa-trash"></i>
    <div (click)=onClick(message) class="content" [innerHTML]="message.htmlText"></div>
  </div>
</div>
